import script from "./AllTransactions.vue?vue&type=script&setup=true&lang=js"
export * from "./AllTransactions.vue?vue&type=script&setup=true&lang=js"

import "./AllTransactions.vue?vue&type=style&index=0&id=5b0acecd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b0acecd"]])

export default __exports__